// AppToolbar — the overflow law's toolbar (Nika 2026-09-26: "you should also
// fix modals, dropdowns, widgets cutting ui and buttons and texts in
// overflow"; HOME_AMBIENT_SKIN_SPEC §3b.5; DESIGN-WL-D2-KIT-OVERFLOW-LAW-1).
//
// A row of controls that never cuts one at its edge:
//   - it WRAPS by default: a control that does not fit starts the next line
//     (one `flex-flow: row wrap` declaration);
//   - on a phone, a control marked `collapse: true` folds away and the ONE
//     square ••• (AppToolbarMore, the kit's CompactIconButton) takes its place,
//     opening the same actions as MenuPanel rows.
//
//   AppToolbar: {
//     Search: { extends: 'AppFieldSearch', … },
//     Export: { extends: 'AppCapsuleBtnToolbar', text: '…', collapse: true },
//     Archive: { extends: 'AppCapsuleBtnToolbar', text: '…', collapse: true },
//     AppToolbarMore: {
//       items: (el, s) => [
//         { key: 'export', text: 'crm.action.export', icon: 'download', onClick: … },
//         { key: 'archive', text: 'crm.action.archive', icon: 'archive', onClick: … }
//       ]
//     }
//   }
//
// The show / hide rules live on the TOOLBAR (`& > [data-…]` class rules), never
// as a `display` on the child: a declared display is written inline and would
// outrank the phone rule (FW-ELEMENT-DECLARED-DISPLAY-WRITTEN-INLINE-BEATS-
// MEDIA-RULES-1).
export const AppToolbar = {
  role: 'toolbar',
  display: 'flex',
  flow: 'x wrap',
  align: 'center flex-start',
  gap: 'Z',
  minWidth: '0',
  maxWidth: '100%',
  childProps: {
    dataCollapse: (el) => !!el.collapse
  },
  '& > [data-toolbar-more]': { display: 'none' },
  '@mobileL': {
    '& > [data-collapse]': { display: 'none' },
    '& > [data-toolbar-more]': { display: 'inline-flex' }
  }
}

// The ••• — the kit's icon-only square (CompactIconButton: 36 px, aspect 1/1,
// the icon-button law). `items`: an array, or a factory of the element and
// its state, of `{ key, text, icon, danger, onClick }`; `text` goes through
// polyglot. A row closes the menu, then runs its own onClick.
export const AppToolbarMore = {
  extends: 'CompactIconButton',
  icon: 'moreHorizontal',
  dataToolbarMore: true,
  ariaHaspopup: 'menu',
  ariaLabel: (el) => el.call('polyglot', 'common.action.moreActions'),
  title: (el) => el.call('polyglot', 'common.action.moreActions'),
  items: [],
  onClick: (e, el, s) => {
    if (e && e.stopPropagation) e.stopPropagation()
    const list = typeof el.items === 'function' ? el.items(el, s) : el.items
    // The row's handler reads its action off the ROW (a flat `action` prop),
    // never a variable captured from this map — a captured one would not
    // survive serialization (frank FA205).
    const rows = (Array.isArray(list) ? list : []).map((item, index) => ({
      key: item.key || 'item' + index,
      text: el.call('polyglot', item.text || ''),
      // a MenuPanelItem row paints its glyph from the Icon child's `name`
      // (a row-level `icon` never reached it)
      ...(item.icon ? { Icon: { name: item.icon } } : {}),
      danger: item.danger,
      action: item.onClick,
      onClick: (ev, row, rs) => {
        row.call('closeDropdown', 'appToolbarMore')
        if (typeof row.action === 'function') row.action(ev, row, rs)
      }
    }))
    el.call('openDropdown', {
      anchorEl: el,
      id: 'appToolbarMore',
      placement: 'bottom-end',
      round: 'radiusCard',
      content: { extends: 'MenuPanel', childExtends: 'MenuPanelItem', children: rows }
    })
  }
}
